import { render, staticRenderFns } from "./CreateAssemblyAreaModal.vue?vue&type=template&id=bb05dc02&"
import script from "./CreateAssemblyAreaModal.vue?vue&type=script&lang=js&"
export * from "./CreateAssemblyAreaModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssemblyAreaModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports